module.exports = __webpack_public_path__ + "img/kjjh_gallery6.5123339b.jpg";